<template>
    <multiselect
        id="headquarters"
        v-model="headquartersSelected"
        :options="authUser().headquarters"
        track-by="uuid"
        label="name"
        :multiple="false"
        :allowEmpty="true"
        placeholder="Sede"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from 'vuex';

    export default {
        name: "UserHeadquartersSelector",
        components: {
            Multiselect
        },
        props: {
            value: Object
        },
        data: function () {
            return {
                headquartersSelected: []
            }
        },
        mounted() {
            this.headquartersSelected = this.evaluateValue(this.value);
        },
        methods: {
            ...mapGetters([
                'authUser'
            ]),
            evaluateValue(value) {
                if (
                    !!value
                    && !!value.uuid
                    && !!this.findHeadquartersByUuid(value.uuid)
                ) {
                    return this.findHeadquartersByUuid(value.uuid);
                } else {
                    return null;
                }
            },
            findHeadquartersByUuid(uuid) {
                if (!!this.authUser().headquarters) {
                    return this.authUser().headquarters.find(headquarters => (headquarters.uuid === uuid));
                } else {
                    return null;
                }
            },
            notifyChange(headquarters) {
                this.$emit('input', headquarters);
            }
        },
        watch: {
            value: function () {
                this.headquartersSelected = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>